export default __webpack_public_path__ + "static/modal4-c78f165fb6d20f3c1a4045c3f91b14c8.png";